module.exports = __webpack_public_path__ + "img/M01.3539783c.png";